import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { CheckAviResponse } from "../response/CheckAviResponse";
import { useAuth } from "../../../auth/context/AuthProvider";

interface CheckAviProps {
    checkin_date: string;
    checkout_date: string;
    booking_id?: string; // Optional, used for existing bookings
    property_id?: string; // Optional, default ke active property user
}

const useCheckAvi = ({ checkin_date, checkout_date, booking_id, property_id }: CheckAviProps) => {
    const { user } = useAuth();
    // /v4/check-room-rate mewajibkan property_id (v3 mengambilnya dari active property di backend)
    const propertyId = property_id || user?.active_property_id;

    return useQuery({
        queryKey: ['booking', 'rooms', 'rates', checkin_date, checkout_date, booking_id, propertyId],
        queryFn: async () => {
            // Definisikan params dasar
            const params: any = {
                checkin_date: checkin_date,
                checkout_date: checkout_date,
                property_id: propertyId,
            };

            // PERBAIKAN 2: Tambahkan booking_id ke params hanya jika ada
            if (booking_id) {
                params.booking_id = booking_id;
            }

            try {
                // Gunakan objek params yang sudah dibuat
                const response = await privateApi.get(`/v4/check-room-rate`, { params });

                // Validasi response
                const validationResult = CheckAviResponse.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid Availability data format");
                }
                return validationResult.data;
            } catch (error) {
                console.error(`Failed to fetch Availability`, error);
                throw error;
            }
        },
        enabled: !!checkin_date && !!checkout_date && !!propertyId,
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false,
    });
};

export default useCheckAvi;
